module.exports = __webpack_public_path__ + "img/stripe.5c548a9f.svg";